import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../operations/queries/get-place-by-id.js';
import '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-code.js';
import '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-code.js';
import { STORES_SEARCH_WITH_INVENTORY } from '../../operations/queries/stores-search.js';
import { mapAvailableFiltersToResults } from '../../utils/map-available-filters-to-results.js';
import '@grandvisionhq/fun-store-filters';

const useStoreSearchWithInventory = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(STORES_SEARCH_WITH_INVENTORY, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            toast.failed('stores.page.search.getStoresByDistance.error');
            console.error('Failed to search stores: ', error);
        }
    });
    var _data;
    const { availableFilters , filteredResults  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>mapAvailableFiltersToResults(availableFilters, filteredResults)
    , [
        availableFilters,
        filteredResults
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useStoreSearchWithInventory as default };
//# sourceMappingURL=use-stores-search-with-inventory.js.map
